import React from "react";
import Image from "../../Image/image";
import { NewsletterLogoProps } from '../newsletterOptin.types';
import { NewsletterLogoContainer } from './newsletterLogo.style';

const NewsletterLogo = ({ logoLight, logoDark, darkTheme }: NewsletterLogoProps) => {
  if (!logoLight) {
    return null;
  }

  return (
    <NewsletterLogoContainer>
      <Image src={darkTheme && logoDark ? logoDark : logoLight} />
    </NewsletterLogoContainer>
  );
};

export default NewsletterLogo;
